import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail, MapPin, Calendar } from "lucide-react";
import { EVENT } from "@/data/site";

export default function Footer() {
  return (
    <footer className="bg-[#F4EFE6] mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid gap-12 md:grid-cols-3">
        <div>
          <div className="font-display text-3xl mb-4">
            mamy<span className="text-[#E6007A]">!</span>kongres
          </div>
          <p className="text-[#5C534D] max-w-sm leading-relaxed">
            Setki mam, które rozumieją jak to jest.<br />
            Formuła wspierająca wymianę doświadczeń i integrację.<br />
            Rozmowy, których nie doświadczysz na Instagramie.
          </p>
        </div>

        <div>
          <h4 className="font-display text-xl mb-4">Kiedy i gdzie</h4>
          <ul className="space-y-3 text-[#5C534D]">
            <li className="flex gap-3 items-start">
              <Calendar className="w-5 h-5 mt-0.5 text-[#E6007A]" />
              <span>{EVENT.dateLong}, {EVENT.hours}</span>
            </li>
            <li className="flex gap-3 items-start">
              <MapPin className="w-5 h-5 mt-0.5 text-[#E6007A]" />
              <span>{EVENT.city}<br />{EVENT.venue}</span>
            </li>
            <li className="flex gap-3 items-start">
              <Mail className="w-5 h-5 mt-0.5 text-[#E6007A]" />
              <a href="mailto:hej@mamykongres.pl" className="hover:text-[#E6007A] transition-colors">hej@mamykongres.pl</a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-xl mb-4">Nawigacja</h4>
          <ul className="space-y-2 text-[#5C534D]">
            <li><Link to="/o-kongresie" className="hover:text-[#E6007A] transition-colors">O kongresie</Link></li>
            <li><Link to="/prelegentki" className="hover:text-[#E6007A] transition-colors">Prelegentki</Link></li>
            <li><Link to="/agenda" className="hover:text-[#E6007A] transition-colors">Agenda</Link></li>
            <li><Link to="/sponsorzy" className="hover:text-[#E6007A] transition-colors">Sponsorzy i partnerzy</Link></li>
            <li><Link to="/wspolpraca" className="hover:text-[#E6007A] transition-colors">Zostań sponsorem</Link></li>
            <li><Link to="/zapisz-sie" className="hover:text-[#E6007A] transition-colors">Zapisz się</Link></li>
            <li><Link to="/kontakt" className="hover:text-[#E6007A] transition-colors">Kontakt</Link></li>
            <li><Link to="/poznajmy-sie" className="hover:text-[#E6007A] transition-colors">Poznajmy się</Link></li>
            <li><Link to="/regulamin" className="hover:text-[#E6007A] transition-colors">Regulamin</Link></li>
            <li><Link to="/polityka-prywatnosci" className="hover:text-[#E6007A] transition-colors">Polityka prywatności</Link></li>
          </ul>

          <div className="flex gap-3 mt-6">
            <a href="https://instagram.com/mamy_kongres" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="w-10 h-10 rounded-full bg-[#FDFBF7] border border-[#E8E1D9] grid place-items-center hover:bg-[#E6007A] hover:text-white hover:border-[#E6007A] transition-colors">
              <Instagram className="w-4 h-4" />
            </a>
            <a href="https://facebook.com/mamykongres" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="w-10 h-10 rounded-full bg-[#FDFBF7] border border-[#E8E1D9] grid place-items-center hover:bg-[#E6007A] hover:text-white hover:border-[#E6007A] transition-colors">
              <Facebook className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-[#E8E1D9]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-8 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div className="flex flex-col sm:flex-row sm:items-center gap-4">
            <span className="text-xs uppercase tracking-[0.3em] text-[#5C534D]">Organizator</span>
            <a
              href="https://fundacjapriorytety.pl"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="fundacja-logo"
              className="inline-flex items-center transition-opacity hover:opacity-80"
            >
              <img
                src="https://customer-assets-cm19k8pv.emergentagent.net/job_mama-congress/artifacts/dkg5rujs_image.png"
                alt="Fundacja Priorytety"
                className="h-10 md:h-12 w-auto"
              />
            </a>
          </div>
          <div className="flex flex-col sm:flex-row sm:items-center gap-3 text-sm text-[#5C534D]">
            <span>
              © {new Date().getFullYear()}{" "}
              <span className="font-display">
                mamy<span className="text-[#E6007A]">!</span>kongres
              </span>. Wszystkie prawa zastrzeżone.
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
